<template>
  <div class="details_form_item">
    <Form ref="detailModel" :model="detailModel" :label-width="130">
      <FormItem label="模板名称：">{{ detailModel.TemplateName }}</FormItem>
      <FormItem label="产品代码：">{{ detailModel.ProductCode }}</FormItem>
      <FormItem label="图片数量：">{{ detailModel.ImageNum }}</FormItem>
      <FormItem label="检查类型：">{{ detailModel.ExamType }}</FormItem>
      <FormItem label="状态：">{{ detailModel.ISActived=="1"?"启用":"禁用" }}</FormItem>
      <FormItem label="所属机构：">{{ detailModel.OrganName }}</FormItem>
      <FormItem label="模板文件："><a target="_black" :href="detailModel.TemplateFileUrl">{{detailModel.TemplateFileName}}</a></FormItem>
    </Form>
    <div class="ml-5 mt-5 text-center modal-foter">
      <Button @click="returnBack">关 闭</Button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["currentData"],
  data: function () {
    return {
      detailModel: {
        TemplateName: null,
        ImageNum: 0,
        ExamType: null,
        OrganName: null,
        ISActived: "1",
        OrganID: null,
        ProductCode: null,
        TemplateFileName: null,
        TemplateFileUrl: null,
      },
    };
  },

  created: function () {
    this.initData();
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },

    initData() {
      let queryData = this.currentData;
      for (let index_1 in this.detailModel) {
        for (let index_2 in queryData) {
          if (index_1.toLocaleLowerCase() == index_2.toLocaleLowerCase()) {
            this.detailModel[index_1] = queryData[index_2];
          }
        }
      }
      this.detailModel.TemplateFileUrl=localStorage.getItem("baseURL")+ this.detailModel.TemplateFileUrl;
    },
  },
};
</script>
<style scoped>
</style>